// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"building-3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15 3V6H18V10H21V21H3V10H6V6H9V3H15Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 15V21H15V15H9Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 15V21H15V15H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 6V3H9V6M15 6H18V10M15 6H9M9 6H6V10M18 10H6M18 10H21V21H3V10H6","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Building3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building-3',
    ref,
    icon: element,
  },
));

Building3Icon.displayName = 'Building3Icon';

export default Building3Icon;
